import { render, staticRenderFns } from "./VendorsTable.vue?vue&type=template&id=20ab07f7&scoped=true"
import script from "./VendorsTable.vue?vue&type=script&lang=js"
export * from "./VendorsTable.vue?vue&type=script&lang=js"
import style0 from "./VendorsTable.vue?vue&type=style&index=0&id=20ab07f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ab07f7",
  null
  
)

export default component.exports